import { adminApiService } from './adminApiService';

export const ReferralService = {
  // Get dashboard stats
  getDashboard: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return adminApiService.get(`/referral/dashboard${queryString ? `?${queryString}` : ''}`);
  },

  // Get all referral codes
  getCodes: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return adminApiService.get(`/referral/codes${queryString ? `?${queryString}` : ''}`);
  },

  // Get single referral code
  getCodeById: async (id) => {
    return adminApiService.get(`/referral/codes/${id}`);
  },

  // Create referral code
  createCode: async (data) => {
    return adminApiService.post('/referral/codes', data);
  },

  // Update referral code
  updateCode: async (id, data) => {
    return adminApiService.put(`/referral/codes/${id}`, data);
  },

  // Delete referral code
  deleteCode: async (id) => {
    return adminApiService.delete(`/referral/codes/${id}`);
  },

  // Get visits for a code
  getVisits: async (id, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return adminApiService.get(`/referral/codes/${id}/visits${queryString ? `?${queryString}` : ''}`);
  },

  // Get signups for a code
  getSignups: async (id, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return adminApiService.get(`/referral/codes/${id}/signups${queryString ? `?${queryString}` : ''}`);
  },

  // Sync stats for a code
  syncStats: async (id) => {
    return adminApiService.post(`/referral/codes/${id}/sync-stats`);
  },

  // Generate URL for a code
  generateUrl: async (id, format = 'hash') => {
    return adminApiService.get(`/referral/codes/${id}/url?format=${format}`);
  },
};

export default ReferralService;
